import get from 'lodash.get';

/** adds and removes event listeners, must 'bind' to component  */
export function handleDimensionEvent() {
  const listenerCallback = setDimsAndOrientation.bind(this);
  return {
    // window may not be available in all testing environments
    eventAvailable:
      typeof window !== 'undefined' &&
      !!window.addEventListener &&
      !!window.removeEventListener,
    // call in componentDidMount
    addDimensionEventListener() {
      window.addEventListener('resize', listenerCallback);
    },
    // call in componentWillUnmount
    removeDimensionEventListener() {
      window.removeEventListener('resize', listenerCallback);
    }
  };
}

/** returns breakpoints object with dimensions and orientation */
export function processPropertiesForState(breakpoints, target) {
  const windowObject = target || (typeof window !== 'undefined' ? window : {});

  return {
    ...windowOrientationProperties(windowObject),
    ...screenProperties(windowObject),
    ...sizeProperties(windowObject, breakpoints),
    ...checkSsrEnv(breakpoints)
  };
}

function setDimsAndOrientation(target) {
  this.setState(
    processPropertiesForState(this.getCurrentBreakpoints(), target)
  );
}

/** get orientation of actual hardware screen */
function screenProperties(target) {
  const orientationType = get(target, 'screen.orientation.type', undefined);
  const widthScreen = get(target, 'screen.width', undefined);
  const heightScreen = get(target, 'screen.height', undefined);
  const landscapeScreen =
    orientationType === 'landscape-primary' ||
    orientationType === 'landscape-secondary';
  const portraitScreen =
    orientationType === 'portrait-primary' ||
    orientationType === 'portrait-secondary';
  if (landscapeScreen || portraitScreen) {
    return {
      landscapeScreen,
      portraitScreen,
      ...(widthScreen && { widthScreen }),
      ...(heightScreen && { heightScreen })
    };
  }
  return {
    ...(widthScreen && { widthScreen }),
    ...(heightScreen && { heightScreen })
  };
}

function windowOrientationProperties(target) {
  if (target.matchMedia) {
    const portraitWindow = target.matchMedia('all and (orientation: portrait)')
      .matches;
    const landscapeWindow = target.matchMedia(
      'all and (orientation: landscape)'
    ).matches;
    if (portraitWindow || landscapeWindow) {
      return {
        portraitWindow,
        landscapeWindow
      };
    }
  }
  return {};
}

function sizeProperties(windowObject, breakpoints) {
  if (windowObject.matchMedia) {
    const { s, m, l } = breakpoints;
    const { innerHeight, innerWidth } = windowObject;
    const match = cssString =>
      windowObject.matchMedia('all and ' + cssString).matches;
    const isL = match(`(min-width: ${l}px)`);
    const isM = !isL && match(`(min-width: ${m}px) and (max-width: ${l}px)`);
    const isS = !isM && match(`(min-width: ${s}px) and (max-width: ${m}px)`);
    const isDefaultSize = !innerWidth || (!isS && match(`(max-width: ${s}px)`));

    return {
      ...(innerHeight ? { heightWindow: innerHeight } : {}),
      ...(innerWidth ? { widthWindow: innerWidth } : {}),

      isDefaultSize,
      isS,
      isM,
      isL
    };
  }
  return {};
}

function checkSsrEnv({ ssrSize }) {
  /* `window` object is 'undefined' when server-side rendering with Next.js.
  Here that condition is used to infer SSR. */
  const isSsr = typeof window === 'undefined';
  if (isSsr) {
    switch (ssrSize) {
      case 'defaultSize':
        return { isDefaultSize: true, isSsr };
      case 's':
        return { isS: true, isSsr };
      case 'm':
        return { isM: true, isSsr };
      case 'l':
        return { isL: true, isSsr };
      default:
        break;
    }
  }
  return {};
}
